import { isValidCpr, Region } from '@monthio/react-components'
import { ValidateCprFunction, ValidateCprAgainstServerFunction } from '../types'
import i18n from 'i18next'
import { getNationalIdentificationNumberErrorTranslation } from '../utils/getNationalIdentificationNumberErrorTranslation'

export const validateCPR: ValidateCprFunction = async (
	cprNumber,
	validateCprAgainstServer: ValidateCprAgainstServerFunction,
) => {
	if (cprNumber == '' || cprNumber == undefined) {
		return {
			success: false,
			output: i18n.t('validation-fieldRequired'),
		}
	}
	const strippedCpr = cprNumber.replace(/[^0-9]/g, '')

	if (strippedCpr.length !== 10) {
		return {
			success: false,
			output: i18n.t(
				'consumerInputs-personalInformationValidation-cprNumberNeedToBe10Characters',
			),
		}
	}
	const validatedCPR = cprNumber.startsWith('0101')
		? isValidCpr(cprNumber, { region: Region.Denmark })
		: isValidCpr(cprNumber, { strict: true, region: Region.Denmark })

	const cprServerResponse = validatedCPR.valid
		? await validateCprAgainstServer(strippedCpr)
		: { isValid: false }

	if (!cprServerResponse.isValid || !validatedCPR.valid) {
		return {
			success: false,
			output: getNationalIdentificationNumberErrorTranslation(
				cprServerResponse.error?.message,
			),
		}
	}

	return {
		success: true,
		output: cprNumber,
	}
}
